import ApiService from './api';

/**
 * Reminder Service
 * Handles all reminder-related API requests
 */
const ReminderService = {
  /**
   * Get all reminders for the current user
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getAllReminders: async (token) => {
    const response = await ApiService.get('/api/reminders', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get upcoming reminders
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getUpcomingReminders: async (token) => {
    const response = await ApiService.get('/api/reminders/upcoming', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get notifications for a specific reminder
   * @param {string} reminderId - Reminder ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getNotifications: async (reminderId, token) => {
    const response = await ApiService.get(`/api/notifications?reminderId=${reminderId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Create a new reminder
   * @param {Object} reminderData - Reminder data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  createReminder: async (reminderData, token) => {
    const response = await ApiService.post('/api/reminders', reminderData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Update a reminder
   * @param {string} reminderId - Reminder ID
   * @param {Object} reminderData - Updated reminder data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  updateReminder: async (reminderId, reminderData, token) => {
    const response = await ApiService.put(`/api/reminders/${reminderId}`, reminderData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Delete a reminder
   * @param {string} reminderId - Reminder ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  deleteReminder: async (reminderId, token) => {
    const response = await ApiService.delete(`/api/reminders/${reminderId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  }
};

export default ReminderService;
